import useWpVideoController from "./useWpVideoController";
import useIncomingRTCAudio from "./useIncomingRTCAudio"
import { localMuteAtom } from "../../recoil/atoms/local-mute";
import { useRecoilState } from "recoil";

const useLocalSpeakerMute = () => {
  const wpVideoController = useWpVideoController()
  const [isMuted, setIsMuted] = useRecoilState(localMuteAtom)
  const { muteRTCIncomingAudio, unmuteRTCIncomingAudio } = useIncomingRTCAudio();

  const muteLocalSpeaker = () => {
    setIsMuted(true)
    muteRTCIncomingAudio()
    wpVideoController.muteAudio()
  }

  const unMuteLocalSpeaker = () => {
    setIsMuted(false)
    unmuteRTCIncomingAudio()
    wpVideoController.unmuteAudio()

  }

  const toggleLocalSpeaker = () => {
    if(isMuted) {
      unMuteLocalSpeaker()
      return
    }
    muteLocalSpeaker()
  }

  return {
    toggleLocalSpeaker,
    muteLocalSpeaker,
    unMuteLocalSpeaker
  }
}

export default useLocalSpeakerMute;
